import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";
export const updateSliderFunc = createAsyncThunk(
  "updateSlider",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await api.put(
        `dashboard/general-settings/sliders/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const updateSliderSlicer = createSlice({
  name: "updateSlider",
  initialState: {
    loading: false,
    data: [],
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateSliderFunc.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.apiErrors = {};
    });
    builder.addCase(updateSliderFunc.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.apiErrors = action.payload?.errors || {};
    });
    builder.addCase(updateSliderFunc.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.successMessage = action.payload?.message || "";
    });
  },
});

export default updateSliderSlicer.reducer;
